import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';

const SEGMENTRON_PREVIEW_CUTOFF_DATE = new Date('2025-09-29T00:00:00Z');

export const isLegacySegmentronReport = (report?: Report): boolean => {
  if (!report?.Created?.At) {
    return true;
  }

  const reportDate = report.Created.At.toDate();
  return reportDate < SEGMENTRON_PREVIEW_CUTOFF_DATE;
};
